import { useState } from 'react';
import { Room, SnapshotImage, Video } from 'src/types';
import { ImageSelector, SelectedImage } from '../ImageSelector';

type ReturnType = {
  imageSelectorModal: React.JSX.Element;
  openImageSelectorModal: () => void;
  selectedImages: SelectedImage[];
  clearImages: () => void;
};

export const useImageSelector = (rooms: Room[], videos: Video[], images: SnapshotImage[]): ReturnType => {
  const [isImagesSelectorOpen, setIsImagesSelectorOpen] = useState(false);
  const [uploadedImages, setUploadedImages] = useState<SelectedImage[]>([]);
  const [selectedImages, setSelectedImages] = useState<SelectedImage[]>([]);

  const imageSelectorModal = (
    <ImageSelector
      isOpen={isImagesSelectorOpen}
      selectedImages={selectedImages}
      uploadedImages={uploadedImages}
      onSelectImage={setSelectedImages}
      onUploadImage={setUploadedImages}
      onClose={() => setIsImagesSelectorOpen(false)}
      rooms={rooms}
      videos={videos}
      images={images}
    />
  );

  return {
    imageSelectorModal,
    openImageSelectorModal: () => setIsImagesSelectorOpen(true),
    selectedImages,
    clearImages: () => {
      setUploadedImages([]);
      setSelectedImages([]);
    },
  };
};
